import { render } from "./PatriotActPage.vue?vue&type=template&id=2ab56df2&scoped=true"
import script from "./PatriotActPage.vue?vue&type=script&lang=js"
export * from "./PatriotActPage.vue?vue&type=script&lang=js"

import "./PatriotActPage.vue?vue&type=style&index=0&id=2ab56df2&scoped=true&lang=css"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab56df2"]])

export default __exports__